import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchExamInstructionRequest,
  getPyqTopicWiseSetsRequest,
  setSelectedSetId,
  setTestDetails,
  setTestType,
} from "../../../../../redux/exam/examSlice";
import "./PyqTopicWiseSet.css";
import { useHistory } from "react-router-dom";
import images from "../../../../../utilities/images/images";
import GameficationMode from "../../../../tests/Dashboard/GameficationMode";
import { fetchBasicAnalyticsRequest } from "../../../../../redux/exam_analytics/analyticsSlice";

const PyqTopicWiseSet = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { pyqTopicWiseSets, activeSubject, selectedTopic, plannerDetails ,selectedType} =
    useSelector((state) => state.examSlice);

  const [gmOpen, setGmOpen] = useState(false);
  const [selectedSet, setSelectedSet] = useState(null);

  const {
    planner_id,
    planner_type_id,
    id: paperType,
    category_id,
  } = plannerDetails || {};

  /* ===================== FETCH SETS ===================== */
  useEffect(() => {
    if (activeSubject && selectedTopic?.topic_name) {
      dispatch(
        getPyqTopicWiseSetsRequest({
          subject: activeSubject,
          topic: selectedTopic.topic_name,
          format: selectedType, 
        })
      );
    }
  }, [dispatch, activeSubject, selectedTopic]);

  /* ===================== OPEN GAMIFICATION MODAL ===================== */
  const handleFooterClick = (set) => {
    setSelectedSet(set);
    setGmOpen(true);
  };

  /* ===================== CONFIRM GAMIFICATION ===================== */
  const handleGamificationConfirm = ({ selectedMode, gamificationOn }) => {
    if (!selectedSet) return;

    // const paperId =
    //   selectedSet.paper_id || selectedSet.test_id || selectedSet.set_id;

    // const testId = selectedSet.test_id || selectedSet.set_id;
    const paperId = undefined;
const testId = undefined;

    dispatch(setSelectedSetId(selectedSet.set_id));
    dispatch(setTestType({ id: paperType }));

    const payload = {
      paperId,
      testId,
      paperType,
      plannerId: planner_id,
      categoryId: category_id || "",
      setId: selectedSet.set_id,
      practiceMode: selectedMode,
      gamificationOn,    
      source: "topicwise",          
    };

    dispatch(setTestDetails(payload));
    dispatch(fetchExamInstructionRequest(payload));

    setGmOpen(false);
    history.push("/TestInstruction");
  };

  /* ===================== UI STATES ===================== */
  if (!pyqTopicWiseSets?.sets?.length) {
    return <div className="loading">Loading sets...</div>;
  }

  const getButton = (set) => {
    // const isLocked = set.is_subscribed === 0;
    // const isStarted = set.attempted_questions > 0;
    // const isCompleted =
    //   set.progress_percentage === 100 ||
    //   set.attempted_questions === set.total_questions;

    if (set.is_subscribed === 0) {
      return (
        <button
          className="practice-btn locked-btn"
          disabled
          onClick={() => history.push(`/store/${set.package_id}`)}
        >
          Locked
        </button>
      );
    }

    if (set.show_reattempt === 1) {
      return (
        <button
          className="practice-btn reattempt-btn"
          onClick={() => handleFooterClick(set)}
        >
          Reattempt ({set.user_attempt_count})
        </button>
      );
    }

    if (set.show_resume === 1) {
      return (
        <button
          className="practice-btn resume-btn"
          onClick={() => handleFooterClick(set)}
        >
          Resume
        </button>
      );
    }

    return (
      <button
        className="practice-btn start-btn"
        onClick={() => handleFooterClick(set)}
      >
        Start Test
      </button>
    );
  };

  /* ===================== RENDER ===================== */
  const handleAnalyticsClick = (set) => {
  // dispatch(
  //   fetchBasicAnalyticsRequest({
  //     paper_type: paperType,
  //     set_id: set.set_id,
  //   })
  // );
history.push("/analytics", {
  paper_type: paperType,
  set_id: set.set_id,
});
 
};
  return (
    <>
      <div className="topic-wise-header">
        <img
          src={images.new_backarrow}
          alt="Back"
          // style={{ width: "24px", height: "24px", cursor: "pointer" }}
          onClick={() => history.push("/practice/topic-wise")}
        />
        <h3 className="header-title">Topic Wise Set</h3>
      </div>

      <div className="container">
        <div className="wrapper">
          <div className="grid">
            {pyqTopicWiseSets.sets.map((set) => {
               const isCompleted = set.analytics_visible === 1;
      return(
              <div key={set.set_id} className="card-pyq">
                <div className="card-header">
                  <div className="circle">  <img src={set.icon} alt="set icon" className="card-icon" /></div>

                  <div className="card-info">
                    <h3 className="set-name">{set.set_name}</h3>
                    <p className="set-details">
                      {set.total_questions} Questions
                      <br />({set.year_range})
                    </p>
                  </div>
                   <div className="card-top-icon" 
                    style={{
    cursor: isCompleted ? "pointer" : "not-allowed",
    opacity: isCompleted ? 1 : 0.5,
  }}
  onClick={() => {
    if (isCompleted) handleAnalyticsClick(set);
  }}>
                    
                <img src={images.topicanalytics_icon} alt="stats icon" />
                </div>
                </div>
                <div className="card-footer">{getButton(set)}</div>
              </div>
      );
            })}
          </div>
        </div>
      </div>

      {/* ===================== GAMIFICATION MODAL ===================== */}
      <GameficationMode
        isOpen={gmOpen}
         attemptUsed={selectedSet?.user_attempt_count || 0}
         attemptMessage={selectedSet?.attempt_message} 
        onClose={() => setGmOpen(false)}
        onConfirm={handleGamificationConfirm}
      />
    </>
  );
};

export default PyqTopicWiseSet;
